import {
  DisgregateResponse,
  ShoppingCartProps,
  TotalPriceObject,
} from '../types/Module';

import {
  getIVATotalPrice,
  mapModulesToShoppingCartProps,
  mapModulesToTerms,
  mapProductOfferingToTerms,
} from './utils';

export const normalizeDisagregateProduct = (
  data: DisgregateResponse,
):
  | {
      originalData: DisgregateResponse;
      shoppingCartProps: ShoppingCartProps;
      termsAndConditions: {
        modulesTerms: string;
        productOfferingTerms: string;
      };
      totalPricesIVA: TotalPriceObject;
    }
  | { isError: boolean; error: any } => {
  try {
    const { modules, productOfferings, totalPrices } = data;
    const originalData = { ...data };
    const totalPricesIVA = getIVATotalPrice(totalPrices);

    const shoppingCartProps = mapModulesToShoppingCartProps(
      modules,
      totalPricesIVA,
      'CUOTA MENSUAL',
    );
    const modulesTerms = mapModulesToTerms(modules);
    const productOfferingTerms = mapProductOfferingToTerms(productOfferings);

    return {
      originalData,
      shoppingCartProps,
      termsAndConditions: {
        modulesTerms,
        productOfferingTerms,
      },
      totalPricesIVA,
    };
  } catch (error) {
    return { error, isError: true };
  }
};
